import React, { FC } from 'react';
import styled from 'styled-components';

const StyledTabsContainer = styled.div`
  display: grid;
  overflow: hidden;
  margin-bottom: 12px;
`;

const StyledTabs = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  padding: 4px 0;

  > * {
    flex-shrink: 0;
  }

  button {
    background: none;
    border: none;
    padding: 4px 8px;
    cursor: pointer;
    font-size: inherit;
    color: inherit;

    &.active {
      background-color: #777;
      color: #fff;
    }
  }
`;

interface Tab {
  label: string;
  value: string;
}

interface SchemaTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (value: string) => void;
}

export const SchemaTabs: FC<SchemaTabsProps> = ({ tabs, activeTab, onTabChange }) => {
  if (tabs.length === 0) return null;

  return (
    <StyledTabsContainer>
      <StyledTabs>
        {tabs.map((t) => (
          <button
            key={t.value}
            type="button"
            className={t.value === activeTab ? 'active' : ''}
            onClick={() => onTabChange(t.value)}
          >
            {t.label}
          </button>
        ))}
      </StyledTabs>
    </StyledTabsContainer>
  );
};
